import { createFileRoute } from '@tanstack/react-router';
import { JobsPage } from '@/page/JobsPage';

export const Route = createFileRoute('/_app/admin/jobs')({ component: JobsPage });
